import styled, { keyframes, css, DefaultTheme } from "styled-components";

export const shimmerAnimation = keyframes`
    0% { background-position: -1000px 0; }
    100% { background-position: 1000px 0; }
`;

const getShimmerGradient = (theme: DefaultTheme): string => {
    const colors = theme.colors[theme.colorMode];
    return `linear-gradient(90deg, ${colors.background_Tertiary} 0%, ${colors.background_Secondary} 52.08%, ${colors.background_Tertiary} 100%)`;
};

// Use background-image (not background shorthand) so theme overrides do not reset background-size.
const shimmerBarMixin = ({ theme }: { theme: DefaultTheme }) => css`
    background-image: ${getShimmerGradient(theme)};
    background-size: 1000px 100%;
    background-repeat: repeat;
    animation: ${shimmerAnimation} 2s infinite linear;
`;

export const OrderContainer = styled.div`
    border-radius: 0 0 24px 24px;
    background: ${({ theme }) => theme.colors[theme.colorMode].background_Primary};
    padding: 20px;
`;

export const SingleLine = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const Circle = styled.div`
    ${shimmerBarMixin}
    width: 20px;
    height: 20px;
    border-radius: 20px;
`;

export const LineShimmer = styled.div<{ widthPercent?: number }>`
    ${shimmerBarMixin}
    width: ${({ widthPercent }) => widthPercent ?? 50}%;
    height: 16px;
    margin-left: 18px;
`;

export const Square = styled.div`
    ${shimmerBarMixin}
    width: 32px;
    height: 32px;
    border-radius: 8px;
`;

export const Rectangle = styled.div`
    ${shimmerBarMixin}
    border-radius: 12px;
    height: 60px;
    margin: 0 16px;
`;

export const TitleShimmer = styled.div<{ widthPercent?: number }>`
    ${shimmerBarMixin}
    height: 16px;
    margin: 46px 0 30px 20px;
    width: ${({ widthPercent }) => widthPercent ?? 30}%;
`;

export const PaymentMethodContainer = styled.div`
    box-shadow: 0px 1px 16px rgba(0, 0, 0, 0.05);
    border-radius: 16px;
    margin: 16px;
    background: ${({ theme }) => theme.colors[theme.colorMode].background_Primary};
    padding: 16px 0;

    &:last-child {
        margin-bottom: 5px;
    }
`;

export const PaymentMethodRow = styled.div`
    display: flex;
    flex: 1;
    padding: 21px 0;
    border-bottom: 1px solid rgba(235, 235, 240, 0.5);
    justify-content: space-evenly;
    align-items: center;

    &:first-child {
        padding-top: 5px;
    }

    &:last-child {
        padding-bottom: 5px;
        border-bottom: none;
    }
`;

export const Row = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 20px 16px 20px 4px;
`;
